export default __webpack_public_path__ + "dcbcbd93bac0470b462db6f9708a658c.woff2";